import { Observable } from "rxjs";
import {
  DeleteAbsenceResponse,
  MappedRetrieveWeeksListAbsenceResponse,
  RetrievePlanningResponse,
} from "../models/personnel.model";

export abstract class PersonnelRepository {
  abstract retrieveResourcePlanning(
    resourceId: number,
  ): Observable<RetrievePlanningResponse>;
  abstract retrieveWeeksListAbsence(): Observable<MappedRetrieveWeeksListAbsenceResponse>;
  abstract deleteAbsence(absenceId: number): Observable<DeleteAbsenceResponse>;
  abstract retrieveWeeklyAbsence(resourceId: number): Observable<any[]>;
}
